var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _vm.resource && !_vm.$wait.is("fetching view resource")
        ? [
            _vm.resource.eventName && _vm.resource.id
              ? _c(
                  "template",
                  { slot: "header" },
                  [
                    _c("h1", [_vm._v(_vm._s(_vm.resource.eventName || " "))]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn--primary",
                        attrs: {
                          to: {
                            name: "edit-event",
                            params: { event_id: _vm.resource.id },
                          },
                        },
                      },
                      [_vm._v("\n                Edit\n            ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("section", { staticClass: "event-info" }, [
              _c("ul", { staticClass: "grid post-details" }, [
                _vm.resource.start
                  ? _c(
                      "li",
                      { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("Start Date"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.resource.start.dateTimeString)),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resource.end
                  ? _c(
                      "li",
                      { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("End Date"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.resource.end.dateTimeString)),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resource.location
                  ? _c(
                      "li",
                      { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("Location"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.resource.location))]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "bilateral-info" }, [
              _c("ul", { staticClass: "grid post-details" }, [
                _vm.resource.bilateralStart
                  ? _c(
                      "li",
                      { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("Bilateral Start Date"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.resource.bilateralStart.displayDate) +
                              ", " +
                              _vm._s(_vm.resource.bilateralStart.displayTime)
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resource.bilateralEnd
                  ? _c(
                      "li",
                      { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("Bilateral End Date"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.resource.bilateralEnd.displayDate) +
                              ", " +
                              _vm._s(_vm.resource.bilateralEnd.displayTime)
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resource.bilateralMeetingRoom
                  ? _c(
                      "li",
                      { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("Meeting Room"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.resource.bilateralMeetingRoom)),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.resource.id
              ? _c(
                  "div",
                  { staticClass: "create" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn--primary",
                        attrs: {
                          to: {
                            name: "create-activity",
                            params: { eventId: _vm.resource.id },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                Create Activity\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.activities
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.activitiesByDate, function (activities, date) {
                      return _c(
                        "div",
                        { key: date, staticClass: "activity-date" },
                        [
                          _c("h2", [_vm._v(_vm._s(date))]),
                          _vm._v(" "),
                          _c(
                            "section",
                            { staticClass: "grid" },
                            _vm._l(activities, function (activity) {
                              return _c("ActivityCard", {
                                key: activity.id,
                                attrs: {
                                  id: activity.id,
                                  activityName: activity.activityName,
                                  activityType: activity.activityTypeFormatted,
                                  backgroundUrl: activity.backgroundUrl,
                                  start: activity.start.dateTimeString,
                                  end: activity.end.dateTimeString,
                                },
                              })
                            }),
                            1
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.otherActivities.length > 0
                      ? _c("div", { staticClass: "other-activities" }, [
                          _c("h2", [_vm._v("Other Activities")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "activity-date" }, [
                            _c(
                              "section",
                              { staticClass: "grid" },
                              _vm._l(
                                _vm.otherActivities,
                                function (otherActivity) {
                                  return _c("ActivityCard", {
                                    key: otherActivity.id,
                                    attrs: {
                                      id: otherActivity.id,
                                      activityName: otherActivity.activityName,
                                      activityType:
                                        otherActivity.activityTypeFormatted,
                                      backgroundUrl:
                                        otherActivity.backgroundUrl,
                                      start: otherActivity.start.dateTimeString,
                                      end: otherActivity.end.dateTimeString,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm.$wait.is("fetching view resource")
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("span", { staticClass: "h2" }, [_vm._v("Loading...")]),
            ]),
          ]
        : !_vm.$wait.is("fetching view resource") && !_vm.resource
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("span", { staticClass: "h2" }, [
                _vm._v("Unable to load event"),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--link",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.fetchResource.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Retry")]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }